export * from './FullScreenSensor';
export type {PointerEvent, PointerEventHandler} from './etc';